export default __webpack_public_path__ + "static/media/fa.bundle.a898c3e9.svg";